import React, { useEffect } from 'react';
import { getAmountWithCurrency } from '@pascal/pascal-core';

import { toFixed } from '../../../../../helpers/arithmeticOperations';
import { globalTranslationKeys } from '../../../../../enums';
import { soundService } from '../../../../../services';

export const YouWinPopUp = ({ t, amount }) => {
  useEffect(() => {
    soundService.playWin();
  }, []);

  const { YouWin, Lose } = globalTranslationKeys;
  return (
    <div className='you-win-wrapper'>
      <div className='you-win-holder'>
        <div className='you-win-content'>
          <div className='you-win-text-container'>
            <span className='you-win-text'>{t(YouWin || Lose)}</span>
          </div>
          <div className='win-price-container'>
            <span className='price-number'>
              {getAmountWithCurrency({ amount: toFixed(amount, 2) })}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
